module.exports = __webpack_public_path__ + "assets/webgl/Assets_1_base_color.jpg.etc.7c503306.ktx";